import {Component, inject, input, Signal} from '@angular/core';
import {Button} from 'primeng/button';
import {TaAuditLogComponent} from '../ta-audit-log/ta-audit-log.component';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {FullTaDetails} from '../../../api';
import {TaAppStore} from '../../../state/clcta-store';

@Component({
  selector: 'ta-audit-log-button',
  imports: [
    Button
  ],
  providers: [
    DialogService,
  ],
  templateUrl: './ta-audit-log-button.component.html',
  styleUrl: './ta-audit-log-button.component.scss'
})
export class TaAuditLogButtonComponent {
  dialogService = inject(DialogService);
  ref: DynamicDialogRef | null | undefined;
  readonly taSubmission = input<FullTaDetails | undefined>();

  modalConfig(): any {
    return {
      header: 'Event History for ' + this.taSubmission()?.taNumber,
      inputValues: {
        taSubmission: this.taSubmission(),
      },
      contentStyle: {
        overflow: 'auto'
      },
      modal: true,
      width: 'fit',
    };
  }

  openEventHistory(): void {
    if (this.taSubmission()) {
      this.ref = this.dialogService.open(TaAuditLogComponent, this.modalConfig());
      this.ref?.onClose.subscribe((data) => {
        // console.log(data);
      });
    } else {
      console.error('No TA submission loaded.')
    }
  }

}
